import { hideAllInMain, showBackButton, prodlistInputQtyPrices } from './uxManagement';
const xml2js = require('xml2js');

export function searchForProducts() {
  const form = document.getElementById('article-search');

  form.addEventListener('submit', function(event) {
    hideAllInMain();
    document.getElementById('search-container').classList.add('visible');
    document.getElementById('cart-container').classList.add('visible');
    event.preventDefault();

    const formData = new FormData(form);
    const searchQuery = formData.get('search-query');

    const productList = document.getElementById('product-list');
    while (productList.firstChild) {
      productList.removeChild(productList.lastChild);
    }

    productLoadIntoList(searchQuery, false);
  });
}

export function productLoadIntoList(searchQuery, qrCode) {
  const productList = JSON.parse(sessionStorage.getItem('product_list'));

  if (productList) {
    hideAllInMain();
    const productListContainer = document.getElementById('product-list-container');
    const productLoading = document.getElementById('product-loading');
    const cart = document.getElementById('cart-container');
    const search = document.getElementById('search-container');
    productListContainer.classList.add('visible');
    productLoading.classList.add('visible');
    cart.classList.add('visible');
    search.classList.add('visible');
    searchQuery = searchQuery.toLowerCase();

    let foundArticle = false;
    if (qrCode) {
      for (let index = 0; index < productList.length; index++) {
        if (searchQuery != null && (productList[index].Itemcode.toLowerCase() == searchQuery || productList[index].EAN.toLowerCase() == searchQuery)) {
          foundArticle = true;
        }
      }
    }
    if (qrCode && !foundArticle) {
      searchQuery = searchQuery.slice(0, -1);
    }
    for (let index = 0; index < productList.length; index++) {
      if (qrCode) {
        searchQuery = searchQuery.replace(/\s/g, '');
        if (searchQuery != null && productList[index].Itemcode.toLowerCase() != searchQuery && productList[index].EAN.toLowerCase() != searchQuery) {
          continue;
        }
      } else {
        if (searchQuery != null && !productList[index].Description.toLowerCase().includes(searchQuery) && !productList[index].Itemcode.toLowerCase().includes(searchQuery) && !productList[index].EAN.toLowerCase().includes(searchQuery)) {
          continue;
        }
      }

      let qtyPrices = '';
      let qtyPricesHiddenInput = '';
      if (productList[index]?.QtyPrices) {
        qtyPrices = '<div class="mt-2 flex gap-x-4"><table class="qty-prices">';
        qtyPrices += '<thead><tr><th class="pr-3 text-sm leading-5 text-gray-500">Antal</th><th class="pr-3 text-sm leading-5 text-gray-500">A-pris</th><th class="pr-3 text-sm leading-5 text-gray-500">Total</th></tr></thead><tbody>';
        let qtyPricesHiddenInputString = '';
        qtyPrices += `
          <tr>
            <td class="text-sm leading-5 text-gray-500">1</td>
            <td class="text-sm leading-5 text-gray-500">${productList[index].Price}</td>
            <td class="text-sm leading-5 text-gray-500">${productList[index].Price}:-</td>
          </tr>
        `;

        if (!Array.isArray(productList[index].QtyPrices.QtyPrice)) {
          productList[index].QtyPrices.QtyPrice = [productList[index].QtyPrices.QtyPrice];
        }

        for (let i = 0; i < productList[index].QtyPrices.QtyPrice.length; i++) {
          qtyPricesHiddenInputString += '{"Qty": "' + productList[index]?.QtyPrices.QtyPrice[i].Qty + '", "Price": "' + productList[index]?.QtyPrices.QtyPrice[i].Price + '"}';
          if (i + 1 < productList[index].QtyPrices.QtyPrice.length) {
            qtyPricesHiddenInputString += ',';
          }
          qtyPrices += '<tr>';

          qtyPrices += '<td class="text-sm leading-5 text-gray-500">' + productList[index]?.QtyPrices.QtyPrice[i].Qty + '</td>';
          qtyPrices += '<td class="text-sm leading-5 text-gray-500">' + productList[index]?.QtyPrices.QtyPrice[i].Price + '</td>';
          const totalPrice = productList[index]?.QtyPrices.QtyPrice[i].Qty * productList[index]?.QtyPrices.QtyPrice[i].Price;
          qtyPrices += '<td class="text-sm leading-5 text-gray-500">' + totalPrice.toFixed(2) + ':-</td>';

          qtyPrices += '</tr>';
        }
        qtyPricesHiddenInput = `, "QtyPrices": [${qtyPricesHiddenInputString}]`;
        qtyPrices += '</tbody></table></div>';
      }

      let productItem = `
      <li class="flex justify-between gap-x-6 py-5">
        <div class="flex min-w-0 gap-x-4">
          <img class="object-contain h-12 w-12 flex-none bg-gray-50" src="https://www.honsboa.se/images/prod450/${productList[index].Picture_Listview}" alt="" onerror="style='object-fit:cover'; this.onerror=null;this.src='/assets/pictures/missing_image.png';">
          <div class="min-w-0 flex-auto">
            <p class="text-sm font-semibold leading-6 text-gray-900">${productList[index].Description}</p>
            <div class="flex gap-x-4">
              <p class="mt-1 truncate text-xs leading-5 text-gray-500">Artikelkod: ${productList[index].Itemcode}</p>
              <p class="mt-1 truncate text-xs leading-5 text-gray-500">Saldo: ${productList[index].Stock}</p>
            </div>
            ${qtyPrices}
          </div>
        </div>
        <div class="grid grid-flow-col gap-4">`;

      if (productList[index].BulkProduct == 'J') {
        productItem += '<div>';
        if (productList[index].Decimals == '1') {
          productItem += '<input type="number" step="0.1" min="0" data-decimals="1" value="1.0" name="item-amount">';
        } else if (productList[index].Decimals == '2') {
          productItem += '<input type="number" min="0" value="1.00" data-decimals="2" step="0.01" name="item-amount">';
        } else {
          productItem += '<input type="number" min="0" value="1" step="1" data-decimals="0" name="item-amount">';
        }
        productItem += '</div>';
      } else {
        productItem += `
          <div class="amount-wrapper">
            <button data-action="decrement" class="h-full cursor-pointer ">
                <span class="m-auto text-2xl font-thin">−</span>
            </button>
            <input class="outline-none focus:outline-none text-center  font-semibold text-md hover:text-black focus:text-black  md:text-basecursor-default flex items-center text-gray-700  outline-none" name="item-amount" data-decimals="0" value="1"></input>
            <button data-action="increment" class="h-full cursor-pointer">
              <span class="m-auto text-2xl font-thin">+</span>
            </button>
          </div>
        `;
      }

      productItem += `<p class="items-center flex">${productList[index].Price} kr</p>
          <button class="buy-button btn text-white bg-lime-500">Köp</button>
          <input type="hidden" value='{"name": "${productList[index].Description}", "item": "${productList[index].Itemcode}", "price": "${productList[index].Price}"${qtyPricesHiddenInput}}'>
        </div>
      </li>`;

      const productListElement = document.getElementById('product-list');
      const placeholder = document.createElement('div');
      placeholder.innerHTML = productItem;
      const node = placeholder.firstElementChild;
      productListElement.appendChild(node);
    }

    prodlistInputQtyPrices();

    const productListElement = document.getElementById('product-list');
    // const productLoader = document.getElementById('product-loading');

    if (productListElement.childElementCount === 0) {
      const placeholder = document.createElement('div');
      placeholder.innerHTML = '<p class="text-center pt-11 text-3xl">Inga produkter hittades</p>';
      const node = placeholder.firstElementChild;
      productListElement.appendChild(node);
    }

    const numberInput = document.querySelectorAll(
      'input[name="item-amount"]'
    );

    numberInput.forEach(input => {
      input.addEventListener('input', validateDecimal, false);
    });

    const decrementButtons = document.querySelectorAll(
      'button[data-action="decrement"]'
    );

    const incrementButtons = document.querySelectorAll(
      'button[data-action="increment"]'
    );

    decrementButtons.forEach(btn => {
      btn.addEventListener('click', decrement);
    });

    incrementButtons.forEach(btn => {
      btn.addEventListener('click', increment);
    });

    addProductToCart();
    productLoading.classList.remove('visible');
    productListElement.classList.add('visible');
    showBackButton();
  }
}

export function saveProductList() {
  const xml = '<?xml version="1.0" encoding="iso-8859-1"?><soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"><soap:Body><GetAllItems><SecretKey>MG65Y0XPmQqNWrLeTCp2Rm11obRDDL7Y</SecretKey></GetAllItems></soap:Body></soap:Envelope>';
  let allItems;

  const xhr = new XMLHttpRequest();
  xhr.addEventListener('load', function() {
    if (this.readyState === 4) {
      const parser = new xml2js.Parser({ explicitArray: false });
      parser.parseString(this.responseText, function(err, result) {
        if (err || result == null) {
          console.log(err);
          console.log('error parsing products');
        } else {
          allItems = result['soap:Envelope']['soap:Body'].GetAllItems.Items.Item;
          sessionStorage.setItem('product_list', JSON.stringify(allItems));
        }
      });
    } else if (this.status >= 400) {
      // TODO prettier error code
      console.log('error fetchin products');
    }
  });

  xhr.open('POST', 'https://butik.honsboa.se/cors.php');
  xhr.setRequestHeader('Content-Type', 'application/xml');
  xhr.send(xml);
}

function addProductToCart() {
  const buyButtons = document.querySelectorAll('.buy-button');

  buyButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      const cart = JSON.parse(localStorage.getItem('cart'));
      const productValues = JSON.parse(button.nextElementSibling.value);
      const keyValueToFind = productValues.item;
      const keyToFind = 'item';
      let isBulk = 'N';
      let noDecimals = 0;
      let amount = 1;
      let confirmAddAmount = false;
      const amountInput = e.target.parentNode.querySelector('[name="item-amount"]');
      if (amountInput) {
        amount = amountInput.value;

        if (cart.some(obj => obj[keyToFind] === keyValueToFind)) {
          for (let i = 0; i < cart.length; i++) {
            if (cart[i][keyToFind] === keyValueToFind) {
              if (confirm('Produkten finns redan i varukorgen, klicka OK om du vill addera till befintligt antal (' + cart[i].qty + ') eller avbryt om du vill ersätta.') == true) {
                cart[i].qty += parseFloat(amount);
                amount = cart[i].qty;
              } else {
                cart[i].qty = parseFloat(amount);
              }
              confirmAddAmount = true;
              break;
            }
          }
        }

        const decimals = amountInput.getAttribute('data-decimals');
        if (decimals == '1') {
          noDecimals = 1;
          isBulk = 'J';
        } else if (decimals == '2') {
          noDecimals = 2;
          isBulk = 'J';
        }
      }

      if (productValues.QtyPrices) {
        if (!Array.isArray(productValues.QtyPrices)) {
          productValues.QtyPrices = [productValues.QtyPrices];
        }
        for (let i = 0; i < productValues.QtyPrices.length; i++) {
          if (parseFloat(amount) >= parseFloat(productValues.QtyPrices[i].Qty)) {
            productValues.price = productValues.QtyPrices[i].Price;
          }
        }
      }

      if (cart.some(obj => obj[keyToFind] === keyValueToFind)) {
        for (let i = 0; i < cart.length; i++) {
          if (cart[i][keyToFind] === keyValueToFind) {
            if (confirmAddAmount) {
              cart[i].amount = parseFloat(productValues.price) * parseFloat(amount);
              cart[i].price = productValues.price;
            } else {
              cart[i].amount = parseFloat(productValues.price) * parseFloat(amount);
            }
            break;
          }
        }
      } else {
        if (productValues) {
          cart.push({
            name: productValues.name,
            item: productValues.item,
            qty: parseFloat(amount),
            price: parseFloat(productValues.price),
            amount: parseFloat(productValues.price) * amount,
            bulkProduct: isBulk,
            decimals: noDecimals
          });
        }
      }

      localStorage.setItem('cart', JSON.stringify(cart));
    });
  });
}

function validateDecimal(e) {
  let newValue = e.target.value;
  let noDecimals = 0;
  if (e.target.getAttribute('data-decimals')) {
    noDecimals = e.target.getAttribute('data-decimals');
  }
  if (noDecimals == 0) {
    newValue = newValue.replace('.', '');
    newValue = newValue.replace(',', '');
    if (isNaN(newValue)) {
      newValue = 1;
    }
    e.target.value = newValue;
  } else {
    if (countDecimals(newValue) > noDecimals) {
      newValue = parseFloat(newValue);
      e.target.value = newValue.toFixed(noDecimals);
    }
  }
}

function countDecimals(value) {
  if ((value % 1) != 0)
    return value.toString().split('.')[1].length;
  return 0;
}

function decrement(e) {
  const changeEvent = new Event('change');
  const btn = e.target.parentNode.parentElement.querySelector(
    'button[data-action="decrement"]'
  );
  const target = btn.nextElementSibling;
  let value = Number(target.value);

  if (value > 1) {
    value--;
    target.value = value;
    target.dispatchEvent(changeEvent);
  }
}

function increment(e) {
  const changeEvent = new Event('change');
  const btn = e.target.parentNode.parentElement.querySelector(
    'button[data-action="decrement"]'
  );
  const target = btn.nextElementSibling;
  let value = Number(target.value);
  value++;
  target.value = value;
  target.dispatchEvent(changeEvent);
}
